export default "__VITE_ASSET__CF$YGzW3__"